import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NavBar.css';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null); // Referencja do menu
  const { user } = useContext(AuthContext);

const handleLogout = () => {
  const loginMethod = user?.loginMethod || 'classic';

  // 1. Wyczyść dane lokalne
  localStorage.clear();

  // 2. Warunkowe wylogowanie
  if (loginMethod === 'microsoft') {
    const redirectAfter = encodeURIComponent('https://parkingapp.x-kom.pl/login');
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${redirectAfter}`;
  } else {
    window.location.href = '/login';
  }
};

  const token = localStorage.getItem('token');


  // Funkcja otwierania/zamykania menu
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  // Zamknięcie menu po kliknięciu poza nim
  useEffect(() => {
    const handleCloseMenu = (event) => {
      if (
        menuRef.current && 
        !menuRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleCloseMenu);
      document.addEventListener('scroll', () => setIsMenuOpen(false));
      document.addEventListener('touchmove', () => setIsMenuOpen(false)); // Obsługa przesunięcia palcem
    }

    return () => {
      document.removeEventListener('mousedown', handleCloseMenu);
      document.removeEventListener('scroll', () => setIsMenuOpen(false));
      document.removeEventListener('touchmove', () => setIsMenuOpen(false));
    };
  }, [isMenuOpen]);
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <a href="/"><img src="/favicon/favicon.ico" alt="Logo" className="navbar-logo" /></a>
        <Link to="/">x-spot Kraków</Link>
      </div>

      {/* Hamburger (widoczny tylko na wąskich ekranach) */}
      <button className="navbar-hamburger" onClick={toggleMenu}>
        ☰
      </button>

      {/* Linki (ukryte na wąskich ekranach, jeśli isMenuOpen = false) */}
      <div ref={menuRef} className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        {token && (
            <>
              <Link to="/" onClick={handleLinkClick}>Rezerwacje</Link>
              <Link to="/spots" onClick={handleLinkClick}>Zajętość miejsc</Link>
              <Link to="/user-panel" onClick={handleLinkClick}>Twój Profil</Link>
              {user?.role === 'admin' && (
                <Link to="/admin" onClick={handleLinkClick}>Administrator</Link>
              )}
            </>
        )}
        {!token ? (
          <Link to="/login"></Link>
        ) : (
          <button onClick={() => { handleLogout(); handleLinkClick(); }} className="logout-btn">
            Wyloguj
          </button>
        )}
      </div>
    </nav>
  );
}

export default NavBar;
